import { IEnvironment } from "./environment.interface";

export const environment: IEnvironment = {
  production: false,
  uriApiAzure: "https://azureapis-pre.elconsentimiento.es/rgpd",
  uriApiAzureLogin: "https://azureapis-pre.elconsentimiento.es",
  vidClientId: "superdocs-online",
  vidIdentityProvider: "https://staging.vidchain.net",
  vidRedirectCallback: "https://rgpdds.azurewebsites.net/guest",
  logLevel: 'info'
};